import { ETicketStatus } from '@constants';
import { Popover } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { SelectorWrapper, StatusWrapper, StatusTextWrapper } from './TicketStatusBadge.styles';

import { EIconType, Icon } from '@/components/Icon';

type Props = {
  status: ETicketStatus;
  editable?: boolean;
  onChange?: (status: ETicketStatus) => void;
};

export const TicketStatusBadge: React.FC<Props> = ({ status, editable, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();

  const handleOpen = (o: boolean) => {
    if (!editable) return;
    setIsOpen(o);
  };

  const handleOnChange = (s: ETicketStatus) => {
    if (!editable) return;
    onChange?.(s);
    setIsOpen(false);
  };

  const getIcon = (s: ETicketStatus): EIconType => {
    switch (s) {
      case ETicketStatus.NEW:
        return 'EmailNew';
      case ETicketStatus.IN_PROGRESS:
        return 'InProgress';
      case ETicketStatus.CLOSED_NOT_RESOLVED:
        return 'CloseFilled';
      case ETicketStatus.CLOSED_RESOLVED:
        return 'Checkmark';
    }
  };

  const content = (
    <SelectorWrapper>
      {Object.values(ETicketStatus).map(s => (
        <StatusWrapper key={ETicketStatus[s]} status={s} onClick={() => handleOnChange(s)}>
          <StatusTextWrapper>
            <Icon i={getIcon(s)} size={14} />
            {t(s)}
          </StatusTextWrapper>
        </StatusWrapper>
      ))}
    </SelectorWrapper>
  );

  return (
    <Popover
      open={isOpen}
      content={content}
      placement="bottom"
      trigger={['click']}
      onOpenChange={handleOpen}>
      <StatusWrapper status={status}>
        <StatusTextWrapper>
          <Icon i={getIcon(status)} size={14} />
          {t(status)}
          {editable && <Icon i="ChevronDown" size={12} />}
        </StatusTextWrapper>
      </StatusWrapper>
    </Popover>
  );
};
